// Bookmarks functionality
import { API_BASE, stories } from './state.js';
import { showToast } from './utils.js';

let userBookmarks = new Set();

export async function loadBookmarks() {
  try {
    const res = await fetch(`${API_BASE}/bookmarks`, { credentials: 'include' });
    const data = await res.json();
    userBookmarks = new Set(data.bookmarks.map(b => b.storyId));
  } catch (e) {
    console.warn('Failed to load bookmarks');
  }
}

export function isBookmarked(storyId) {
  return userBookmarks.has(storyId);
}

export async function toggleBookmark(storyId, event) {
  event?.stopPropagation();
  
  const story = stories.find(s => s.id === storyId);
  if (!story) return;
  
  const wasBookmarked = userBookmarks.has(storyId);
  const btn = document.querySelector(`[data-bookmark="${storyId}"]`);
  
  // Optimistic UI update
  if (btn) {
    btn.classList.toggle('active', !wasBookmarked);
    const svg = btn.querySelector('svg');
    if (svg) svg.setAttribute('fill', wasBookmarked ? 'none' : 'currentColor');
  }
  
  try {
    if (wasBookmarked) {
      const res = await fetch(`${API_BASE}/bookmarks/${storyId}`, { 
        method: 'DELETE', 
        credentials: 'include' 
      });
      if (!res.ok) throw new Error('Delete failed');
      userBookmarks.delete(storyId);
      showToast('Removed from saved');
    } else {
      const res = await fetch(`${API_BASE}/bookmarks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          storyId: story.id,
          headline: story.headline,
          category: story.category,
          clusterId: story.id
        })
      });
      if (!res.ok) throw new Error('Save failed');
      userBookmarks.add(storyId);
      showToast('Saved for later');
    }
  } catch (error) {
    // Revert optimistic update on failure
    if (btn) {
      btn.classList.toggle('active', wasBookmarked);
      const svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', wasBookmarked ? 'currentColor' : 'none');
    }
    console.error('Bookmark error:', error);
    showToast('Failed to save', 'error');
  }
}

export { userBookmarks };
